export const homeObjOne = {
  id: "aboutus",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "บ้านพระคุณกรุงเทพ",
  heading: "พันธกิจของเราทำอะไร?",
  description:
    "เราไม่ได้ทำอะไรใหม่ เราไม่ได้ทำอะไรแปลก เราทำในสิ่งที่ควรจะทำ สู้ในสิ่งที่ควรจะสู้  เรารอดโดยพระคุณผ่านทางความเชื่อ (อฟ.2:8) เราก็จะยืนในพระคุณ (โรม 5:2) ไม่เดินในทางของคนอธรรม (สดด1) และเราจะเติบโตขึ้นในพระคุณ (2 ปต 3:18)  การใช้ชีวิตของเรา คือ การออกประกาศ  เสริมสร้างผู้ติดตามหรือสาวก และสอนให้พวกเขารักที่จะถือรักษาสิ่งที่พระคริสต์ได้มอบให้  เรารัก..ที่จะเห็นคนมาเชื่อพระเจ้า..และเดินกับพระเจ้า..และเติบโตขึ้นกับพระเจ้า",
  buttonLabel: "null",
  imgStart: false,
  // img: require('../../images/outreach-1.jpg').default,
  img: "null",
  embedId: "nzWlHRasBIk",
  alt: "Be One in Father",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjTwo = {
  id: "leadershipOne",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "ศิษยาภิบาล",
  heading: "ภูมิ อัครทวีทอง",
  description:
    "ดำรงตำแหน่งเป็นศิษยาภิบาลคริสตจักรบ้านพระคุณกรุงเทพ(Greater Grace Church of Bangkok) ตั้งแต่ ปี 2016  ซึ่งอยู่ภายพันธกิจ  Greater Grace World Outreach, USA   (GGWO) ซึ่งมีนิมิตในการก่อตั้งคริสตจักรท้องถิ่นโดยปัจจุบันมีคริสตจักรในสังกัด 1,500 คริสตจักรทั่วโลก และมีนิมิตในการออกประกาศและสร้างสาวกผ่านทางการศึกษาโรงเรียนพระคัมภีร์ ศบ.อาร์ม จบปริญญาตรีนิติศาสตร์บัณฑิต จากมหาวิทยาลัยรามคำแหง จบการศึกษาจากสำนักอบรมกฎหมาย เนติบัญฑิตไทย พร้อมกับจบการศึกษาจากวิทยาลัยพระคัมภีร์ MARYLAND BIBLE COLLEGE & SEMINARY ประเทศสหรัฐอเมริกา เข้าร่วมพันธกิจตั้งปี 2006 ในขณะศึกษาอยู่ที่มหาวิทยาลัยรามคำแหง มีบทบาทในการรับใช้พันธกิจโดยการเทศนา ออกประกาศ และสอนในโรงเรียนพระคัมภีร์ Greater Grace Bible School of Bangkok  เป็นศิษยาภิบาลคนไทยคนแรกที่ได้รับแต่งตั้ง หลังจากพันธกิจ GGWO ได้มาบุกเบิก ณ ประเทศไทย โดยปัจจุบันทำงานเป็นทนายความและร่วมรับใช้พันธกิจ ศบ.อาร์มมักมีคำพูดที่ติดปากว่า.....ผมไม่รู้จักคำว่า.... “รับใช้เต็มเวลาคืออะไร ?..... รู้แต่เพียงแค่ว่า “ ข้าฯพระองค์อยู่ตรงนี้แล้ว”",
  buttonLabel: "null",
  imgStart: true,
  img: require("../../images/pastor-arm.jpg").default,
  // img: "null",
  embedId: "null",
  alt: "Be One in Father",
  dark: true,
  primary: true,
  darkText: true,
};

export const homeObjThree = {
  id: "leadershipTwo",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "ผู้ปกครอง",
  heading: "เอ็ดวิน สีบุญเรือง",
  description:
    "ดำรงตำแหน่งผู้ปกครองคริสตจักรบ้านพระคุณกรุงเทพ จบการศึกษาจากมหาวิทยาลัย Arkansas ด้าน Food Science และจบการศึกษาระดับปริญาโท เอกด้านการสอนภาษาอังกฤษ ที่มหาวิทยาลัย Assumption University  ประเทศไทย พร้อมได้รับรองเป็นผู้เชี่ยวชาญด้านการสอนจากมหาวิทยาลัย Nottingham University ประเทศอังกฤษ  ปัจจุบันดำรงตำแหน่งเป็นอาจารย์ผู้สอนที่โรงเรียนนานาชาติ Bangkok International Christian  School \n"+
    "เอ็ดวิน เข้าร่วมพันธกิจตั้งแต่ปี 2010 ทำหน้าที่เป็นนักประกาศและมีส่วนร่วมในการก่อตั้งคริสตจักรบ้านพระคุณแม่สอด ชีวิตเต็มไปด้วยสีสันแห่งการรับใช้ เอ็ดทำหน้าที่เป็นทั้งอาจารย์ผู้สอนในโรงเรียนพระคัมภีร์ Greater Grace Bible School of Bangkok พร้อมทั้งเป็นผู้บริหารจัดการงานในคริสตจักร เป็นเพื่อนผู้รับใช้และได้รับการไว้วางใจจากพันธกิจ GGWO ในแต่งตั้งเอ็ดวินเป็น Elder หรือผู้ปกครองร่วมจัดการงานกับศิษยาภิบาลในคริสตจักร",
  buttonLabel: "null",
  imgStart: false,
  img: require("../../images/leader-2.jpg").default,
  // img: "null",
  embedId: "null",
  alt: "Be One in Father",
  dark: true,
  primary: true,
  darkText: false,
};
